import {HttpClient} from "@angular/common/http";
import {inject, Service} from "@angular/core";
import type {IJsonObject} from "dcerialize";
import {Deserialize} from "dcerialize";
import type {Observable} from "rxjs";
import {map} from "rxjs";
import type {IPaginated, IPaginationQuery} from "../../models/IPaginated";
import {News} from "../../models/News/News";
import {NewsEntry} from "../../models/News/NewsEntry";
import {BaseApiService} from "./base-api.service";

@Service()
export class NewsService extends BaseApiService {
  private readonly http = inject(HttpClient);

  public constructor() {
    super("news");
  }

  private applyDefaultSorting(paginationQuery?: IPaginationQuery): IPaginationQuery {
    return {
      sortBy: {
        field: "created-at",
        direction: "descending",
      },
      ...(paginationQuery ?? {}),
    };
  }

  public getNews(paginationQuery?: IPaginationQuery): Observable<IPaginated<NewsEntry>> {
    return this.http.get<IJsonObject>(this.getEndpointUrl(), {
      params: this.httpParamsFromPaginationQuery(this.applyDefaultSorting(paginationQuery)),
    }).pipe(map(m => Deserialize(m, () => News)));
  }

  public getNewsByAuthor(author: string, paginationQuery?: IPaginationQuery): Observable<IPaginated<NewsEntry>> {
    const endpoint = this.getEndpointUrl("by-author", author);
    const params = this.httpParamsFromPaginationQuery(this.applyDefaultSorting(paginationQuery));
    return this.http.get<IJsonObject>(endpoint, {params}).pipe(map(m => Deserialize(m, () => News)));
  }

  public getNewsByTag(tag: string, paginationQuery?: IPaginationQuery): Observable<IPaginated<NewsEntry>> {
    const endpoint = this.getEndpointUrl("by-tag", tag);
    const params = this.httpParamsFromPaginationQuery(this.applyDefaultSorting(paginationQuery));
    return this.http.get<IJsonObject>(endpoint, {params}).pipe(map(m => Deserialize(m, () => News)));
  }

  public getNewsById(postId: number): Observable<NewsEntry> {
    return this.http.get<IJsonObject>(this.getEndpointUrl(postId.toFixed()))
      .pipe(map(m => Deserialize(m, () => NewsEntry)));
  }
}
